import { api } from "../api";

export const subscription = api.injectEndpoints({
    endpoints: (builder) => ({ 
        getPlans: builder.query({
            query: ({ planType }) => ({
                url: `/plans?planType=${planType}`,
            }),
            transformResponse: (response, meta, arg) => response.data,
        }), 
        createCheckout: builder.mutation({
            query: ({ payload }) => ({
                url: `/stripe/create-checkout-session`,
                method: 'POST',
                body: payload,
            }),
            invalidatesTags: ['Subscription'],
        }),  
        getSubscriptions: builder.query({
            query: () => ({
                url: `/subscriptions`,
            }),
            transformResponse: (response, meta, arg) => response.data,
        }),
        getSubscriptionById: builder.query({
            query: (id) => ({
                url: `/subscriptions/${id}`,
            }),
            transformResponse: (response, meta, arg) => response.data,
        }),   
        getCustomer: builder.query({
          query: () => ({
              url: `/stripe/customer`,
          }),
          transformResponse: (response, meta, arg) => response.data,
        }),  
        checkPaymentMethod: builder.query({
          query: (customerId) => ({
            url: `/stripe/check-payment-method/${customerId}`,
          }),
          transformResponse: (response, meta, arg) => response.data,
        }),  
        addPaymentMethod: builder.mutation({
            query: ({ customerId }) => ({
                url: `/stripe/attach-payment-method/${customerId}`,
                method: 'PUT',
            }),
        }),
        updatePaymentMethod: builder.mutation({
            query: ({ subscriptionId, payload }) => ({
                url: `/subscriptions/update-payment-method/${subscriptionId}`,
                method: 'PUT',
                body: payload,
            }),
        }),
        detachPaymentMethod: builder.mutation({
            query: ({ cardId }) => ({
                url: `/stripe/detach-payment-method/${cardId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Subscription'],
        }), 
        activateSubscription: builder.mutation({
            query: ({ subscriptionId }) => ({
                url: `/subscriptions/activate/${subscriptionId}`,
                method: 'PUT',
            }),
        }),
        upgradePlan: builder.mutation({
            query: ({ payload, subscriptionId }) => ({
                url: `/subscriptions/upgrade/${subscriptionId}`,
                method: 'PUT',
                body: payload,
            }),
        }),
        cancelSubscription: builder.mutation({
          query: ({ subscriptionId }) => ({
              url: `/subscriptions/${subscriptionId}`,
              method: 'DELETE',
          }),
          invalidatesTags: ['Subscription'],
        }), 
        paymentDue: builder.mutation({
            query: ({ subscriptionId }) => ({
                url: `/subscriptions/get-payment-url/${subscriptionId}`,
                method: 'POST',
            }),
            invalidatesTags: ['Subscription'],
        }),
        resumeSubscription: builder.mutation({
            query: ({ subscriptionId }) => ({
                url: `/subscriptions/resume-subscription/${subscriptionId}`,
                method: 'PUT',
            }),
        }),
        buyCredits: builder.mutation({
            query: ({ payload }) => ({
                url: `/stripe/buy-credits`,
                method: 'POST',
                body: payload
            }),
            invalidatesTags: ['Subscription'],
        }), 
    }),
});

export const {
    useCreateCheckoutMutation,
    useGetSubscriptionsQuery,
    useLazyGetSubscriptionsQuery,          
    useGetSubscriptionByIdQuery,
    useLazyGetSubscriptionByIdQuery,       
    useGetCustomerQuery,
    useCheckPaymentMethodQuery,
    useAddPaymentMethodMutation,
    useUpdatePaymentMethodMutation,
    useUpgradePlanMutation,
    useDetachPaymentMethodMutation,
    useActivateSubscriptionMutation,
    useCancelSubscriptionMutation,
    usePaymentDueMutation,
    useResumeSubscriptionMutation,
    useGetPlansQuery,
    useBuyCreditsMutation
  } = subscription;
  
